import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconMinutesSmsProps } from './IconMinutesSms.types'
import * as Styled from './styles/IconMinutesSms.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMinutesSms: FC<IconMinutesSmsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMinutesSmsProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconMinutesSmsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path d='M19.285 4.516h-4.57m4.57 1.968h-4.57m6.738-2.453V2.598H20' vectorEffect='non-scaling-stroke' />
          <path
            d='M20 2.598h-6.34c-.613 0-1.113.496-1.113 1.113v3.707a1.111 1.111 0 0 0 1.113 1.113h4.152l2.157 2.031v-2.03h.375c.293 0 .578-.118.785-.325.21-.21.328-.492.324-.789V4.031M7.95 5.07l1.183 3.301.027.086a.374.374 0 0 1-.125.426 4.34 4.34 0 0 1-1.27.664 7.656 7.656 0 0 1-1.68.328.364.364 0 0 0-.308.473 12.259 12.259 0 0 0 3.02 4.968 12.37 12.37 0 0 0 5 3.008.365.365 0 0 0 .457-.242.182.182 0 0 0 .012-.066c.05-.567.164-1.13.336-1.668.152-.457.378-.883.668-1.262a.373.373 0 0 1 .43-.125l.085.027 3.317 1.18c.789.277 1.816.57 2.367.84.008 0 0 .015 0 .023a3.447 3.447 0 0 1-.145 1.258c-.375 1.219-1.387 2.527-2.582 2.875-3.015.898-6.191-.023-9-1.43a12.146 12.146 0 0 1-5.383-5.359c-1.418-2.79-2.343-5.95-1.441-8.95C3.273 4.239 4.59 3.23 5.812 2.86l.95-.25c.18-.05.363.051.426.227Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconMinutesSms
